import { gql } from "apollo-boost"

export const getAssistantsCount = gql`
query CensusAssitantsCount {
  CensusAssistantsCount
}
`